import { collection, getDocs, query, where, limit } from 'firebase/firestore';
import { useFirestore, useAuth } from '../hooks/useFirebase';
import { DailyPostType } from '../interfaces/dailyPostType';

export const name = 'readDailyCollection';
export const description = 'Reads daily posts directly from Firestore, optionally filtered by project_number.';
export const parameters = {
  project_number: 'Optional project number (e.g. "M-22-04") to filter daily posts by.'
};
export const outputTextForUI = 'Napi bejegyzések lekérése';
export const useOnMobile = true;

export async function readDailyCollection(args?: { project_number?: string }) {
  const db = useFirestore();
  const user = useAuth();

  const projectNumber = args?.project_number;
  let q;

  if (projectNumber) {
    q = query(
      collection(db, 'daily'),
      where('user_id', '==', user.uid),
      where('project_number', '==', projectNumber),
      limit(50)
    );
  } else {
    q = query(
      collection(db, 'daily'),
      where('user_id', '==', user.uid),
      limit(50)
    );
  }

  const snapshot = await getDocs(q);
  const posts: DailyPostType[] = [];

  snapshot.forEach((doc) => {
    posts.push({
      id: doc.id,
      ...doc.data()
    } as DailyPostType);
  });

  // Sort by date descending in-memory to prevent missing composite index errors in Firestore
  posts.sort((a, b) => {
    const timeA = a.date?.seconds || 0;
    const timeB = b.date?.seconds || 0;
    return timeB - timeA;
  });

  return {
    success: true,
    count: posts.length,
    posts
  };
}
